<script setup lang="ts">
import { NMessageProvider, enGB, dateEnGB, darkTheme } from "naive-ui";
import {
    NNotificationProvider,
    NConfigProvider,
    NLoadingBarProvider,
} from "naive-ui";
import { computed, onMounted } from "vue";
import MessageProviderSetup from "@/Components/MessageProviderSetup.vue";
import NotificationHandler from "@/Components/NotificationHandler.vue";
import { initTheme, isDark } from "@/util/theme";

const themeOverrides = {
    //...
};

// naive-ui components follow the app's light/dark choice; the Bootstrap/Limitless
// chrome is flipped via the data-bs-theme attribute set inside theme.ts.
const naiveTheme = computed(() => (isDark.value ? darkTheme : null));

onMounted(() => {
    initTheme();
});
</script>

<template>
    <NConfigProvider
        :locale="enGB"
        :date-locale="dateEnGb"
        :theme="naiveTheme"
        :theme-overrides="themeOverrides"
    >
        <NMessageProvider>
            <NNotificationProvider>
                <NLoadingBarProvider
                    :loading-bar-style="{
                        loading: {
                            height: '3px',
                            backgroundColor: '#2e9236',
                            display: 'none',
                        },
                    }"
                >
                    <MessageProviderSetup />
                    <NotificationHandler />
                    <router-view
                        :key="$route.name"
                        v-slot="{ Component, route }"
                    >
                        <div :key="route.name">
                            <Component :is="Component" />
                        </div>
                    </router-view>
                </NLoadingBarProvider>
            </NNotificationProvider>
        </NMessageProvider>
    </NConfigProvider>
</template>
